export default __webpack_public_path__ + "02025408a122c62f9a64a77f9c15c62e.svg";